import { combineReducers } from "redux";
import Customizer from "./customizer/reducer";
import UserReducer from "./user/reducer";

const reducers = combineReducers({
  Customizer,
  UserReducer,
});

export default reducers;
